// ULID generado en el cliente.
//
// Es la clave de idempotencia de la venta: se genera ANTES de mandar el
// pedido, así que si la respuesta se pierde (se corta el wifi, se recarga la
// pantalla) reintentar con el mismo id devuelve la misma venta en lugar de
// duplicarla.
//
// Es el gemelo de Application/Common/Ulid.cs, y el formato tiene que ser el
// mismo porque el servidor valida la forma antes de aceptarlo.

/** Base32 de Crockford: sin I, L, O ni U, para poder leerlo por teléfono. */
const ALFABETO = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

export const Ulid = {
  /** 26 caracteres: 10 de tiempo en base32 + 16 de azar. */
  nuevo(momento: Date = new Date()): string {
    let ms = momento.getTime()
    let tiempo = ''

    for (let i = 0; i < 10; i++) {
      tiempo = ALFABETO[ms % 32] + tiempo
      ms = Math.floor(ms / 32)
    }

    // crypto.getRandomValues y no Math.random: son 80 bits que tienen que ser
    // impredecibles y, sobre todo, no repetirse entre dos cajas generando ids
    // en el mismo milisegundo.
    const bytes = new Uint8Array(16)

    if (typeof crypto !== 'undefined' && 'getRandomValues' in crypto) {
      crypto.getRandomValues(bytes)
    } else {
      // Sin crypto (contextos muy viejos) se degrada a Math.random. No es
      // ideal, pero es mejor que no poder emitir una venta.
      for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
    }

    let azar = ''
    for (const b of bytes) azar += ALFABETO[b % 32]

    return tiempo + azar
  },

  /** Valida la forma: 26 caracteres del alfabeto. */
  esValido(valor: string | null | undefined): boolean {
    if (!valor || valor.length !== 26) return false

    for (const c of valor.toUpperCase()) if (!ALFABETO.includes(c)) return false

    return true
  },
}
